module.exports = __webpack_public_path__ + "img/logo.233bdc1c.png";